import React from 'react';
import { getInitials } from '../../../utils/nameUtils';
import styles from './ChannelInitialIcon.module.css';

interface ChannelInitialIconProps {
  channelName: string | null | undefined;
  className?: string;
  size?: number;
  borderRadius?: string;
}

const ChannelInitialIcon: React.FC<ChannelInitialIconProps> = ({
  channelName,
  className = '',
  size = 40,
  borderRadius
}) => {
  const initials = getInitials(channelName);

  return (
    <div 
      className={`${styles.channelInitialIcon} ${className}`}
      style={{ 
        width: size, 
        height: size, 
        fontSize: size * 0.4,
        borderRadius: borderRadius || '50%'
      }}
    >
      {initials}
    </div>
  );
};

export default ChannelInitialIcon;

